/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveLinkItemDto
 */
export interface SaveLinkItemDto {
    /**
     * 
     * @type {string}
     * @memberof SaveLinkItemDto
     */
    existingId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveLinkItemDto
     */
    type: SaveLinkItemDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveLinkItemDto
     */
    salesInvoiceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveLinkItemDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof SaveLinkItemDto
     */
    originalAmount: string;
    /**
     * 
     * @type {string}
     * @memberof SaveLinkItemDto
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveLinkItemDto
     */
    originalComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveLinkItemDto
     */
    toDelete: boolean;
}


/**
 * @export
 */
export const SaveLinkItemDtoTypeEnum = {
    Invoice: 'Invoice',
    Withdrawal: 'Withdrawal',
    Return: 'Return',
    Correction: 'Correction'
} as const;
export type SaveLinkItemDtoTypeEnum = typeof SaveLinkItemDtoTypeEnum[keyof typeof SaveLinkItemDtoTypeEnum];


/**
 * Check if a given object implements the SaveLinkItemDto interface.
 */
export function instanceOfSaveLinkItemDto(value: object): value is SaveLinkItemDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('originalAmount' in value) || value['originalAmount'] === undefined) return false;
    if (!('toDelete' in value) || value['toDelete'] === undefined) return false;
    return true;
}

export function SaveLinkItemDtoFromJSON(json: any): SaveLinkItemDto {
    return SaveLinkItemDtoFromJSONTyped(json, false);
}

export function SaveLinkItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveLinkItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'existingId': json['existingId'] == null ? undefined : json['existingId'],
        'type': json['type'],
        'salesInvoiceId': json['salesInvoiceId'] == null ? undefined : json['salesInvoiceId'],
        'amount': json['amount'],
        'originalAmount': json['originalAmount'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'originalComment': json['originalComment'] == null ? undefined : json['originalComment'],
        'toDelete': json['toDelete'],
    };
}

export function SaveLinkItemDtoToJSON(value?: SaveLinkItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'existingId': value['existingId'],
        'type': value['type'],
        'salesInvoiceId': value['salesInvoiceId'],
        'amount': value['amount'],
        'originalAmount': value['originalAmount'],
        'comment': value['comment'],
        'originalComment': value['originalComment'],
        'toDelete': value['toDelete'],
    };
}

